import { gsap } from "../../node_modules/gsap/index.js";
import { ScrollTrigger } from "../../node_modules/gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "../../node_modules/gsap/ScrollToPlugin.js";
import { Utilities } from "./utilities.js";

//gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);


export class siteAnimations {

    markers = false;

    // Banner Animated
    bannerAnimatedBock = '.banner-animated-block';
    bannerAnimatedOverlayLeft = '.banner-animated-block--animated-overlay.overlay-left';
    bannerAnimatedOverlayRight = '.banner-animated-block--animated-overlay.overlay-right';

    constructor() {
        window.addEventListener('spinnerStopped', () => {
            this.bannerAnimateds();
            //this.productStripeAnimation();
            this.columnsBlockAnimation();
            //this.galleryBlockAnimation();
            //this.commonBannerAnimation();
            //this.imageTextBlockAnimation();
        });
    }

    bannerAnimatedSize() {

        let mm = gsap.matchMedia();

        mm.add( "(min-width: 1023px)", () => {
            const windowWidth = jQuery(window).innerWidth();
            //console.log("windowWidth: " + windowWidth);
            const container = windowWidth * 0.5342;
            //console.log(container);
            const sideSpacer = (windowWidth - container) / 2;
            const blockLeftAndRight = container + sideSpacer;

            jQuery(this.bannerAnimatedBock).find(this.bannerAnimatedOverlayLeft).css("right", blockLeftAndRight + "px");
            jQuery(this.bannerAnimatedBock).find(this.bannerAnimatedOverlayRight).css("left", blockLeftAndRight + "px");
        });

    }

    bannerAnimatedSizeOnResize() {
        jQuery(window).resize(() => {
            console.log("Window is resizing");
            //this.bannerAnimatedSize();
        });
    }

    bannerAnimateds() {

        const scrub = false;
        const duration = 1;

        if ( Utilities.elementExits(this.bannerAnimatedBock) ) {

            //this.bannerAnimatedSize();
            //this.bannerAnimatedSizeOnResize();

            gsap.utils.toArray(this.bannerAnimatedBock).forEach(block => {

                gsap.to(block.querySelectorAll('.banner-animated-block--animated-overlay.overlay-left'), {
                    scrollTrigger: {
                        trigger: block, // start animation when ".box" enters the viewport
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                        scrub: scrub,
                    },
                    right: "100%",
                    duration: duration,
                    ease: "power4.inOut",
                });

                gsap.to(block.querySelectorAll('.banner-animated-block--animated-overlay.overlay-right'), {
                    scrollTrigger: {
                        trigger: block, // start animation when ".box" enters the viewport
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                        scrub: scrub,
                    },

                    left: "100%",
                    duration: duration,
                    ease: "power4.inOut",
                });

                const contents = block.querySelectorAll('.banner-animated-block--content');

                const onlyContents = Array.from(contents).filter(el => el.classList.length === 1 && el.classList.contains('banner-animated-block--content'));

                if (onlyContents.length > 0) {
                    gsap.from(onlyContents, {
                        backgroundPosition: "50% 100%",
                        ease: "none",
                        scrollTrigger: {
                            trigger: block,
                            scrub: 0.5
                        }
                    });
                }

            });

        }
    }

    /*
        Common Banner Animation
        -----------------------------------------
        This animation is used on demand on the common isolatiberina Banner Block
    */
    commonBannerAnimation() {
        const banner_element = '.banner-block.banner-animated';
        if ( Utilities.elementExits(banner_element) ) {
            gsap.utils.toArray(banner_element).forEach(banner => {
                gsap.from(banner, {
                    scrollTrigger: {
                        trigger: banner, // start animation when ".box" enters the viewport
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                    },
                    y: "20%",
                    opacity: 0.2,
                    duration: 0.8,
                    ease: "power1.out"
                });
            });
        }
    }

    /* WooCommerce Product Stripe Animation */
    productStripeAnimation() {
        if ( Utilities.elementExits(".product-stripe--product") ) {
            gsap.from(".product-stripe--product", {
                scrollTrigger: {
                    trigger: ".product-stripe", // start animation when ".box" enters the viewport
                    toggleActions: "restart none resume none",
                    markers: this.markers,
                },
                y: "20%",
                opacity: 0.2,
                stagger: 0.1,
                duration: 0.5,
                ease: "power1.out"
            });
        }
    }

    /* Gallery Block Animation */
    galleryBlockAnimation() {

        const gallery_wrapper = '.galery-block';
        const gallery_column = '.galery-block--col';

        if ( Utilities.elementExits(gallery_wrapper) ) {
            gsap.utils.toArray(gallery_wrapper).forEach(gallery => {
                gsap.from(gallery.querySelectorAll(gallery_column), {
                    scrollTrigger: {
                        trigger: gallery, // start animation when ".box" enters the viewport
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                    },
                    y: "20%",
                    opacity: 0.2,
                    stagger: 0.1,
                    duration: 0.7,
                    ease: "power1.out"
                });
            });
        }

    }

    /* Image and Text Block Animation */
    imageTextBlockAnimation() {


        const imgAndTxt_wrapper_left = ".image-and-text-block.align-desktop-left"
        const imgAndTxt_wrapper_right = ".image-and-text-block.align-desktop-right"
        const imgAndTxt_image = '.image-and-text-block--image';
        const imgAndTxt_text = '.image-and-text-block--text';

        const animation_options = {
            x: "20%",
            opacity: 0.2,
            stagger: 0.1,
            duration: 0.7,
            ease: "power1.out"
        };

        /*
            Left Aligment Block Animation
            -----------------------------------------
        */
        if ( Utilities.elementExits(imgAndTxt_wrapper_left) ) {
            gsap.utils.toArray(imgAndTxt_wrapper_left).forEach(imgAndTxt_left => {
                gsap.from(imgAndTxt_left.querySelectorAll(imgAndTxt_image), {
                    scrollTrigger: {
                        trigger: imgAndTxt_left,
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                    },
                    x: "-" + animation_options.x,
                    opacity: animation_options.opacity,
                    stagger: animation_options.stagger,
                    duration: animation_options.duration,
                    ease: animation_options.ease
                });
                gsap.from(imgAndTxt_left.querySelectorAll(imgAndTxt_text), {
                    scrollTrigger: {
                        trigger: imgAndTxt_left,
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                    },
                    x: animation_options.x,
                    opacity: animation_options.opacity,
                    stagger: animation_options.stagger,
                    duration: animation_options.duration,
                    ease: animation_options.ease
                });
            });
        }

        /*
            Right Aligment Block Animation
            -----------------------------------------
        */
        if ( Utilities.elementExits(imgAndTxt_wrapper_right) ) {
            gsap.utils.toArray(imgAndTxt_wrapper_right).forEach(imgAndTxt_right => {
                gsap.from(imgAndTxt_right.querySelectorAll(imgAndTxt_image), {
                    scrollTrigger: {
                        trigger: imgAndTxt_right,
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                    },
                    x: animation_options.x,
                    opacity: animation_options.opacity,
                    stagger: animation_options.stagger,
                    duration: animation_options.duration,
                    ease: animation_options.ease
                });
                gsap.from(imgAndTxt_right.querySelectorAll(imgAndTxt_text), {
                    scrollTrigger: {
                        trigger: imgAndTxt_right,
                        toggleActions: "restart none resume none",
                        markers: this.markers,
                    },
                    x: "-" + animation_options.x,
                    opacity: animation_options.opacity,
                    stagger: animation_options.stagger,
                    duration: animation_options.duration,
                    ease: animation_options.ease
                });
            });
        }

    }

    /* WP Columns Block Animation */
    columnsBlockAnimation() {
        const banner_element = '.columns-animated';
        if ( Utilities.elementExits(banner_element) ) {
            gsap.utils.toArray(banner_element).forEach(banner => {
                gsap.from(banner, {
                    scrollTrigger: {
                        trigger: banner,
                        toggleActions: "play none none none",
                        markers: this.markers,
                    },
                    y: "20%",
                    opacity: 0.2,
                    duration: 1.8,
                    ease: "power1.out"
                });
            });
        }
    }

}


